import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "react-bootstrap/Form";
import useDarkMode from "use-dark-mode";

const DarkModeSlider = () => {
  const darkMode = useDarkMode(false);
  return (
    <div className="d-flex h-100 align-items-center">
      <Form.Switch
        id="dark-mode"
        checked={darkMode.value}
        label={<FontAwesomeIcon icon={darkMode.value ? "moon" : "sun"} />}
        onChange={darkMode.toggle}
      />
    </div>
  );
};

export default DarkModeSlider;
